import React, { Component } from 'react';

export default class Actions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionObj: {},
      rolePermissionsArr: [],
    };
    this.onActionClick = this.onActionClick.bind(this);
    this.renderPermissions = this.renderPermissions.bind(this);
  }

  componentWillMount() {
    this.setState({
      actionObj: this.props.actionPermissionObj,
      rolePermissionsArr: this.props.rolePermissionsArr,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      actionObj: nextProps.actionPermissionObj,
      rolePermissionsArr: nextProps.rolePermissionsArr,
    });
  }

  onActionClick(e, actionPermission) {
    e.preventDefault();
    let actionCheckedValue = actionPermission ? false : true;

    // update Role permissions - For action
    this.renderPermissions(this.state.actionObj, actionCheckedValue);
  }

  renderPermissions(actionObj, actionCheckedValue) {

    // set permission for a action in final permission
    let actionPermissionsArr = this.state.rolePermissionsArr.data.actionPermissions;
    let parentScreenPermissionFlag = false;
    let count = 0;
    let screenIdCount = 0;
    actionPermissionsArr.map((obj) => {
      if (obj.screenId === actionObj.screenId) {
        screenIdCount = screenIdCount + 1;
        if (obj.actionId === actionObj.actionId) {
          obj.permission = actionCheckedValue;
        }
        
        if (obj.permission === true) {
          count = count + 1;          
          parentScreenPermissionFlag = true;
          
        }
        if (obj.permission === false) {
          count = count - 1;
        }
      }
      return obj;
    });

    actionObj['permission'] = actionCheckedValue; // set permission for a action in local scope.

    this.setState({
      actionObj: actionObj,
      rolePermissionsArr: this.state.rolePermissionsArr,
    });
    this.props.getFinalData(this.state.rolePermissionsArr, parentScreenPermissionFlag);
  }

  render() {
    return (
      <tr key={this.state.actionObj.actionKey}>
        <td width="50%">{this.state.actionObj.actionName}</td>
        <td width="50%">
          <button
            type="button"
            name={'ACTION_' + this.state.actionObj.actionId}
            className="addnum"
            title="Action permission"
            onClick={(e) => this.onActionClick(e, this.state.actionObj.permission)}>
            <i className={`${this.state.actionObj.permission ? 'fa fa-check-square greenfont' : 'fa fa-minus-square redfont' }`} aria-hidden="true"></i>
          </button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Masters/components/role-permission/containers/actions.js